export default __webpack_public_path__ + "static/media/480_dummy2016-yoga01-mobile-de.af57ceee.png";